import './ServiceA.scss';

export default function ServiceA() {
	return (
		<section>
			<div className='container'>
				<div className='title-vanuardia text-center py-4'>
					<h2 className='display-3 fw-bold'>Ekklexia a la Vanguardia</h2>
					<p className='text-center lead'>
						Envíos y servicios especializados de logística para empresas, consultoría e
						ingeniería de negocios.
					</p>
				</div>
				<div className='row'>
					<div className='col-12 col-md-6 col-lg-4'>
						<div className='card h-80 border-primary-color shadow-lg p-3 mb-5 rounded bg-primary-color'>
							<div className='text-center pt-2'>
								<i className='bi bi-stopwatch style-icon-service-hover'></i>
							</div>
							<div className='card-body'>
								<h5 className='card-title text-center h2 fw-bold text-white'>
									Tiempos de Entrega
								</h5>
								<p className='card-text text-center px-4 text-white'>
									Entregas días siguiente o mismo día en todas las ciudades donde tenemos
									presencia y con una eficiencia mayor al 99%
								</p>
							</div>
						</div>
					</div>
					<div className='col-12 col-md-6 col-lg-4'>
						<div className='card h-80 border-primary-color shadow-lg p-3 mb-5 rounded'>
							<div className='text-center pt-2'>
								<i className='bi bi-truck style-icon-service'></i>
							</div>
							<div className='card-body'>
								<h5 className='card-title text-center h2 fw-bold'>Parque Vehicular</h5>
								<p className='card-text text-center px-4 text-muted'>
									Contamos con más de 200 vehículos de distintas capacidades desde 1 hasta
									25 toneladas para los diferentes servicios que ofrecemos.
								</p>
							</div>
						</div>
					</div>
					<div className='col-12 col-md-6 col-lg-4'>
						<div className='card h-80 border-primary-color shadow-lg p-3 mb-5 rounded bg-primary-color'>
							<div className='text-center pt-2'>
								<i className='bi bi-map style-icon-service-hover'></i>
							</div>
							<div className='card-body'>
								<h5 className='card-title text-center h2 fw-bold text-white'>
									Flexibilidad
								</h5>
								<p className='card-text text-center px-4 text-white'>
									Tenemos la capacidad para crecer rápida y exponencialmente en unidades,
									ajustándonos a los requerimientos y variaciones de volumen que presenten
									nuestros clientes.
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
